import React, { ReactElement, isValidElement } from 'react'
import { BottomSheet } from '@s4l/ds'
import { CreateDescriptionBlocks } from './utils'

interface Props {
  item: string
  isOpen: boolean
  onClose: () => void
}

interface ItemsInterface {
  key: string
  title: string
  content: string | ReactElement
}
type ItemsType = ItemsInterface[]

const VoucherInfoModal = ({ item, isOpen, onClose }: Props) => {
  const descriptionToRender = (items: ItemsType) => {
    return items.map(({ title, content }) => ({
      title,
      content: isValidElement(content) ? content : null,
    }))
  }

  const [{ title, content } = { title: '', content: null }] = descriptionToRender(
    CreateDescriptionBlocks(item)
  )

  return (
    <BottomSheet open={isOpen} onClose={onClose}>
      <BottomSheet.Content title={title} modalOnDesktop>
        {content}
      </BottomSheet.Content>
    </BottomSheet>
  )
}

export default VoucherInfoModal
